import React from 'react';
import { useTranslation } from 'react-i18next';
import { Trash2 } from 'shared/assets/icons';
import { Checkbox } from 'shared/components/ui/checkbox';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenu,
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';
import { ResizableTextArea } from 'shared/components/ui/resizable-text-area';
import { SortableContainer } from 'shared/components/ui/sortable-container';
import { useContextMenuState } from 'shared/hooks/use-context-menu-state';
import { DraggableOptions } from 'shared/types/draggable-types';
import { ID } from 'shared/types/id';

import * as Styled from './sub-task-card.style';

export type NewTaskSubTaskProps = {
  id: ID;
  name: string;
  onChange: (id: ID, name: string) => void;
  onDelete: (id: ID) => void;
};

export const NewTaskSubTask: React.FC<NewTaskSubTaskProps> = ({
  id,
  name,
  onChange,
  onDelete,
}) => {
  const { t } = useTranslation();
  const [updatedName, setUpdatedName] = React.useState(name);
  const onSubmitChange = () =>
    updatedName !== name && onChange(id, updatedName);

  const _onChange = (newName: string) => {
    onChange(id, newName || name);
    setUpdatedName(newName);
  };
  const _onDelete = () => onDelete(id);

  const { position, open, close } = useContextMenuState();

  return (
    <SortableContainer id={id} type={DraggableOptions.Task}>
      <Styled.Container onContextMenu={open}>
        <Checkbox checked={false} readOnly isPlaceholder={!updatedName} />
        <ResizableTextArea
          value={updatedName}
          onChange={_onChange}
          onBlur={onSubmitChange}
        />
      </Styled.Container>
      {!!position && (
        <PopupMenu location={position} onOutside={close}>
          <PopupMenuList>
            <PopupMenuListItem>
              <PopupMenuButton
                onClick={_onDelete}
                start={<Icon icon={Trash2} />}
              >
                {t('context-menus.task.labels.delete')}
              </PopupMenuButton>
            </PopupMenuListItem>
          </PopupMenuList>
        </PopupMenu>
      )}
    </SortableContainer>
  );
};
